import { Col, Row } from "antd";
import { useRouteMatch } from "react-router";
import { Box, Flex } from "@chakra-ui/layout";
import { useState } from "react";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import { TabMenuOptions, TabsMenuOptionsRoutes } from "./typings";
import history from "infra/helpers/history";
import CardDefault from "components/Cards/CardDefault";
import { useLocation } from "react-router-dom";
import PageHeader from "components/Page/PageHeader";
import Container from "components/Container";
import DadosOrcamento from "./components/DadosOrcamento/index";
import Cotacoes from "./components/Cotacoes/index";

function OrcamentoDetalhesPage() {
  const route = useRouteMatch<{ id: string; tenant: string }>();

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const opcaoParam = !route.params.id
    ? TabsMenuOptionsRoutes.Dados
    : (params.get("opcao") as string) || TabsMenuOptionsRoutes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (route.params.id) {
      history.push(`/administracao/orcamento/${route.params.id}?opcao=${tab}`);
    } else {
      history.push(`/administracao/orcamento/new?opcao=${tab}`);
    }
  };

  if (!opcaoParam) {
    return null;
  }

  return (
    <Container pb="32px">
      <PageHeader
        title={
          <Flex gap="8px" fontWeight="bold">
            Orçamento
          </Flex>
        }
      />

      <Row gutter={32}>
        <Col sm={6}>
          <Box mb={4} pt="0px" flex={1}>
            <MenuDetalhes<TabsMenuOptionsRoutes>
              disabledOptions={
                !route.params.id ? [TabsMenuOptionsRoutes.Cotacoes] : []
              }
              options={TabMenuOptions}
              selectedOption={selectedMenuOption as TabsMenuOptionsRoutes}
              onChangeOption={(tab) => {
                handleChangeMenu(tab);
              }}
            />
          </Box>
        </Col>

        <Col sm={18}>
          {selectedMenuOption === TabsMenuOptionsRoutes.Dados ? (
            <CardDefault>
              <DadosOrcamento id={route.params.id} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Cotacoes ? (
            <Cotacoes id={route.params.id} />
          ) : null}
        </Col>
      </Row>
    </Container>
  );
}

export default OrcamentoDetalhesPage;
